import { apiClient, apiGet, apiPost, apiPut, apiDelete } from "@/lib/api/client";
import type { PaginatedParams, PaginatedResponse } from "@/lib/api/types";

const BASE = "/tasks";

export const tasksApi = {
  list: (params?: PaginatedParams & { status?: string; priority?: string }) => {
    const searchParams = new URLSearchParams();
    if (params?.page) searchParams.set("page", String(params.page));
    if (params?.perPage) searchParams.set("perPage", String(params.perPage));
    if (params?.sort) searchParams.set("sort", params.sort);
    if (params?.order) searchParams.set("order", params.order);
    if (params?.status) searchParams.set("status", params.status);
    if (params?.priority) searchParams.set("priority", params.priority);
    return apiGet<PaginatedResponse<Record<string, unknown>>>(`${BASE}?${searchParams.toString()}`);
  },

  getById: (id: string) => apiGet<{ task: Record<string, unknown> }>(`${BASE}/${id}`),

  create: (data: Record<string, unknown>) => apiPost<{ task: Record<string, unknown> }>(BASE, data),

  update: (id: string, data: Record<string, unknown>) =>
    apiPut<{ task: Record<string, unknown> }>(`${BASE}/${id}`, data),

  delete: (id: string) => apiDelete<{ message: string }>(`${BASE}/${id}`),

  complete: (id: string) => apiPost<{ task: Record<string, unknown> }>(`${BASE}/${id}/complete`),

  reassign: (id: string, userId: string) =>
    apiPut<{ task: Record<string, unknown> }>(`${BASE}/${id}/reassign`, { userId }),
};
